import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()

export class FutureInfoService {

  private _token: string = localStorage.getItem('token');
  constructor(
    private http: Http,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  postFutureInfo$(info: any): Observable<any> {
    const token = this._token;
    const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': token});
    return this.http.post(this.config.apiEndpoint + 'futureinfo/add-future-information', info, {
        headers: headers
      })
      .catch(this.handleErrorObservable);
  }

  getFutureInfo(info: any): Observable<any> {

    const headers = new Headers({ 'Authorization': this._token });
    const options = new RequestOptions({ headers: headers });
    return this.http.post(this.config.apiEndpoint + 'futureinfo/get-future-information', info, options)
      .map((res: Response) => res.json()) // ...and calling .json() on the response to return data
    .catch(this.handleErrorObservable); // ...errors if any

  }

  postSecondarysList() {
    const token = this._token;
    const headers = new Headers({ 'Authorization': token });
    const options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'futureinfo/get-post-secondary', options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }

  postSecondarysListByname = (startsWith: string): Observable<any[]> => {
    const token = this._token;
    const headers = new Headers({ 'Authorization': token });
    const options = new RequestOptions({ headers: headers });
    /* return this.http.get(this.config.apiEndpoint + 'academicinfo/get-high-schoolby-name/'+startsWith)
    .map(h => h.json()) */
    return this.http.get(this.config.apiEndpoint + 'futureinfo/get-post-secondaryby-name/' + startsWith, options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }


  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/future-info.service.ts